angular.module('common.filter.dutyexpression.description', ['common.config', 'common.filter.description']).filter('dutyExpressionDescription', function($filter, CONSTANTS){
    return function(dutyExpressions, measurementUnitCode) {
        if (!dutyExpressions){
            return null;
        }
        var dutyExpressionDescription = $filter('description')(dutyExpressions);
        if (CONSTANTS.showMeasurementUnitCode && measurementUnitCode){
            dutyExpressionDescription = dutyExpressionDescription + " (" + measurementUnitCode + ")";
        }
        return dutyExpressionDescription;
  };
});



// WEBPACK FOOTER //
// ./app/common/filter/duty-expression-description-filter.js